import translations from "./translations";

// Langues du parcours, dans l'ordre de la maquette (écran 1f). Les noms restent
// dans leur propre langue. Module sans initialisation d'i18next : le sélecteur de
// langue peut l'importer sans démarrer i18n (tests compris).
export const LANGUAGES = [
    { code: "fr", label: "Français", flag: "fr" },
    { code: "en", label: "English", flag: "gb" },
    { code: "es", label: "Español", flag: "es" },
    { code: "de", label: "Deutsch", flag: "de", isNew: true },
    { code: "nl", label: "Nederlands", flag: "nl", isNew: true },
];

export const supportedLanguages = () => Object.keys(translations);

// localStorage peut être indisponible (navigation privée, stockage bloqué) :
// la langue n'est alors simplement pas retenue.
export const storedLanguage = () => {
    try {
        return localStorage.getItem("lang");
    } catch (e) {
        return null;
    }
};

export const rememberLanguage = (code) => {
    try {
        localStorage.setItem("lang", code);
    } catch (e) {
        // Pas de persistance possible : la langue vaut pour cette visite.
    }
};
